module.exports = __webpack_public_path__ + "static/media/img_faceassessmenton_face_ratio.4caf1e10.jpg";